<template>
  <div class="stage-test-completed">
    <div class="content">
      <div class="close" @click="onClose"></div>
      <div class="text">
        <div>
          <span>{{info.name}}</span>
          <span>同学，在本次阶段测试中取得了</span>
          <span>{{info.score}}</span>
          <span>分的成绩，本次考试用时{{time}}，完成了{{info.count}}道大题。</span>
        </div>
        <div>特发此证，以资鼓励。</div>
      </div>
      <div class="name">百项过智能学习中心</div>
      <div class="foot">
        <div>{{info.schoolName}}</div>
        <div>{{date}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/services/utils';

export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    time() {
      return utils.secondsToTime(this.info.seconds, {
        hours: '时',
        minutes: '分',
        seconds: '秒',
      });
    },
    date() {
      return utils.Date.format(new Date(), 'yyyy年MM月dd日');
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import "@/styles/common/dialog.scss";
  .stage-test-completed {
    display: flex;
    position: absolute;
    left: 80px;
    top: 0;
    right: 0;
    flex-grow: 1;
    height: 100%;
    min-width: 1300px;
    min-height: 700px;
    overflow-x: auto;
    background: rgba(30, 32, 58, 0.3);
    .content {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      width: 156vh;
      height: 84vh;
      background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/8cf6a34d5ca34b082638c0ae5ef76b66.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .close {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 4vh;
        height: 4vh;
        z-index: 2;
        background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/e4f688b8d4e34ef78964f2cef65f5138.png')
          no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
      .text {
        position: absolute;
        top: 34vh;
        left: 36vh;
        width: 86vh;
        height: 4vh;
        font-size: 2vh;
        z-index: 2;
        line-height: 4vh;
        font-weight: bold;
        color: $font-color;
        div:nth-of-type(1) {
          span:nth-of-type(1) {
            display: inline-block;
            padding: 0 2.5vh;
            font-size: 2.4vh;
            text-align: center;
            line-height: 3vh;
            color: $primary;
            border-bottom: 2px solid $font-color;
          }
          span:nth-of-type(3) {
            display: inline-block;
            padding: 0 1vh;
            font-size: 3vh;
            text-align: center;
            color: $primary;
            line-height: 3vh;
            border-bottom: 2px solid $font-color;
          }
        }
        div:nth-of-type(2) {
          margin-left: 4vh;
        }
      }
      .name {
        position: absolute;
        top: 63vh;
        left: 36vh;
        height: 4vh;
        font-size: 2vh;
        z-index: 2;
        line-height: 4vh;
        font-weight: bold;
        color: $font-color;
      }
      .foot {
        position: absolute;
        top: 61.8vh;
        left: 106vh;
        height: 4vh;
        font-size: 2vh;
        z-index: 2;
        line-height: 3.2vh;
        font-weight: bold;
        color: $font-color;
        text-align: end;
      }
    }
  }
</style>
